import { DatepickerCalendarPresetsStyled } from './styles/DatepickerCalendarPresetsStyled'
import { BaseButton } from '@ui/elements/Button/BaseButton'
import { Spacer } from '@ui/elements/Spacer'
import { SubText } from '@ui/elements/Text'

export interface IDatepickerCalendarPresetsProps {
  title?: string
  presets: {
    label: string
    [x: string]: any
  }[]
  onClick: (preset) => void
}

export const DatepickerCalendarPresets = ({
  title,
  presets = [],
  onClick = () => undefined,
}: IDatepickerCalendarPresetsProps) => {
  return (
    <DatepickerCalendarPresetsStyled>
      {title && <SubText>{title}</SubText>}
      {title && <Spacer space={0.5} />}
      {presets.map((preset, index) => (
        <li key={index}>
          <BaseButton type='button' onClick={() => onClick(preset)}>
            {preset.label}
          </BaseButton>
        </li>
      ))}
    </DatepickerCalendarPresetsStyled>
  )
}

DatepickerCalendarPresets.displayName = 'DatepickerCalendarPresets'
